import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { usePopper } from 'react-popper';
import { Empty, Option, Loading, Fetching } from './components';
import { useClassName } from '../../../../hooks';
import { useClearText, useOnScroll, useScrollReset, useUpdatePosition, useOptionsWidth } from './hooks';
import './Options.scss';
export const Options = ({ options, loading, onScrollEnd, onSearch, fetching, onSelect, removable, onDelete, optionsAreOpen, value, setValue, selectedValues, setCurrentIndex, currentIndex, mode, setOptionsAreOpen, setFocused, optionsCache, inputRef, }) => {
    const className = useClassName({
        name: 'auto-complete-options',
        prefixed: true,
    }, !optionsAreOpen && 'hidden');
    const ref = useRef(null);
    const { styles, attributes, update } = usePopper(inputRef.current, ref.current, {
        placement: 'bottom-start',
        strategy: 'fixed',
    });
    const width = useOptionsWidth({ inputRef });
    const onScroll = useOnScroll({ ref, onScrollEnd });
    useScrollReset({ ref, optionsAreOpen });
    useClearText({ optionsCache, mode, selectedValues, onSearch, optionsAreOpen, setValue });
    useUpdatePosition({ selectedValues, update });
    return (_jsxs("div", { onScroll: onScroll, ref: ref, "data-testid": 'auto-complete-component-options', className: className, style: { ...styles.popper, width }, ...attributes, children: [!loading &&
                options.map((option, index) => (_jsx(Option, { optionsAreOpen: optionsAreOpen, setFocused: setFocused, setOptionsAreOpen: setOptionsAreOpen, mode: mode, index: index, setCurrentIndex: setCurrentIndex, currentIndex: currentIndex, setValue: setValue, option: option, onDelete: onDelete, onSelect: onSelect, removable: option.removable ?? removable, selectedValues: selectedValues }, option.value))), _jsx(Fetching, { fetching: fetching, loading: loading }), _jsx(Empty, { value: value, options: options, loading: loading }), _jsx(Loading, { loading: loading })] }));
};
